export enum ContentItemStatusActionEnum {
  Approve = 'approve',
  Reject = 'reject',
}

export enum ContentItemStatusEnum {
  Approved = 'approved',
  Rejected = 'rejected',
  New = 'new',
}
